import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// ========== DISABLE CONSOLE IN PRODUCTION ==========
if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
  // Keep console.warn and console.error for critical issues
}

// Global error handlers to catch unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  // Suppress browser extension errors
  if (event.reason?.message?.includes('message channel closed')) {
    event.preventDefault();
    console.warn('Suppressed browser extension error:', event.reason);
    return;
  }
  
  // Log other unhandled rejections for debugging
  console.error('Unhandled promise rejection:', event.reason);
});

// Global error handler
window.addEventListener('error', (event) => {
  // Suppress browser extension errors
  if (event.message?.includes('message channel closed')) {
    event.preventDefault();
    console.warn('Suppressed browser extension error:', event.message);
    return;
  }
  
  console.error('Global error:', event.error);
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

